import {CALL_API} from 'redux-api-middleware';
import {
  API_CONFIG_GET_REQUEST,
  API_CONFIG_GET_SUCCESS,
  API_CONFIG_GET_FAILURE,
} from 'common/types';
import {ENDPOINT_CONFIGURATION} from 'common/endpoints';
import {commonJwtHeader} from 'common/utils';

export default {
  getConfig: (token, entityType, entityId, configType, configId) => {
    return {
      [CALL_API]: {
        endpoint: `${ENDPOINT_CONFIGURATION}configs/${entityType}/${entityId}/${configType}/${configId}`,
        headers: commonJwtHeader(),
        method: 'GET',
        types: [API_CONFIG_GET_REQUEST, API_CONFIG_GET_SUCCESS, API_CONFIG_GET_FAILURE],
      },
    };
  },
};
